import { slider } from "./modules/slider.js";
import { header } from "./modules/header.js";
import { advertasing } from "./modules/advertasing.js";
import { swiper } from "./modules/swiper.js";
import { blog } from "./modules/blog.js";
import { singlepost } from "./modules/single-post.js";
import { slick } from "./modules/slick.js";

document.addEventListener("DOMContentLoaded", function (event) {
    slider();
    header();
    advertasing();
    blog();
    singlepost();
    slick();
    

    //Contact fom

    $(document).ready(function () {

        function openForm() {
            $('body').addClass('blackout');
            $('.contact-form1-popup').fadeIn(100).addClass('contact-form1-popup_open');
            var scrollbarWidth = window.innerWidth - $(document).width();
            $(':root').css('--scrollbar-width', scrollbarWidth + 'px');
            $('body').addClass('popup-open');
        }

        // $('.contact-form1-start').on('click', function (event) {
        //     event.preventDefault();
        //     openForm();
        // });

        $('a[href="#"]').on('click', function (event) {
            event.preventDefault();
            openForm();
        });


        $('.contact-form1__close').on('click', function () {
            closeForm();
        });

        $(document).on('click', function (event) {

            if (!$(event.target).closest('.contact-form1-popup').length &&
                !$(event.target).closest('.contact-form1-start').length &&
                !$(event.target).is('a[href="#"]')) {
                closeForm();
            }
        });

        function closeForm(blackout = true) {
            $('.contact-form1-popup form')[0].reset();
            $('.contact-form1-popup').fadeOut(100, function () {
                $(this).removeClass('contact-form1-popup_open');
                if (blackout) {
                    $('body').removeClass('blackout');
                }
                $(':root').css('--scrollbar-width', '');
                $('body').removeClass('popup-open');
            });
        }

        const $formSubmitMessage = $('.form-submit-message');

        if ($formSubmitMessage.length) {
            $(document).on('wpcf7mailsent', function (event) {
                $formSubmitMessage.addClass('form-submit-message_open');

                if (!$('body').hasClass('blackout')) {
                    $('body').addClass('blackout');
                }

                setTimeout(function () {
                    $formSubmitMessage.removeClass('form-submit-message_open');
                    $('body').removeClass('blackout');
                }, 8000);

                closeForm(false);
            });

            $formSubmitMessage.on('click', '.form-submit-message__close', function () {
                $formSubmitMessage.removeClass('form-submit-message_open');
                $('body').removeClass('blackout');
            });

            $(document).on('click', function (event) {
                if ($formSubmitMessage.hasClass('form-submit-message_open')) {
                    if (!$formSubmitMessage.is(event.target) && $formSubmitMessage.has(event.target).length === 0) {
                        $formSubmitMessage.removeClass('form-submit-message_open');
                        $('body').removeClass('blackout');
                    }
                }
            });
        }


    });

    //Contact form /


    //Custom file input
    var fileInput = document.getElementById('contact-form2-file');
    var fileNameDisplay = document.getElementById('file-name');

    if (fileInput && fileNameDisplay) {
        fileInput.addEventListener('change', function () {
            var fileName = this.files.length > 0 ? this.files[0].name : '';
            fileNameDisplay.textContent = fileName;
        });
    }

    

});
